import React, {Component} from 'react';

export default class Select extends Component {

    renderOptions(listValues, isRequired) {

        return listValues.map((el, i)=>{

            // const selected = isRequired && i === 0;
            const rndKey=Math.floor(Math.random() * Math.floor(1000000));
            return (
                <React.Fragment key={rndKey}>
                <option value={el}>{el}</option>
                </React.Fragment>
            );
        });
    }

    render() {
        const fieldParams = this.props.field;

        if(!fieldParams
            || !fieldParams.hasOwnProperty("list_values")) {
            return null;
        }

        const isRequired = !!fieldParams['is_required'];

        return (

            <select name={fieldParams["name"]} required={isRequired}>
                {this.renderOptions(fieldParams["list_values"], isRequired)}
            </select>

        )
    }
}
